import React, { useRef, useState, useEffect } from "react";
import Highcharts, { chart } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { LOGO, VERTICALS } from "../../../../constants/app-constant";
import { getInlineFilterText, getTimelineText, getTimelineTextPosition } from "../../../../utility/common-methods";

export function DoughnutChartHC({
  graphApiResponse: { hcData = [{}] },
  chartTitle,
  onEntityClick,
  showPercentage,
  dataByReportType,
  type,
  identifier,
  setGraphRef,
  setGraphRefList,
  mediaType,
  isEmbededWidget,
  to_date,
  from_date,
  dateHash,
  widget,
  selectedInlineJournalist,
  selectedInlinePlatform,
  selectedInlinePublication,
  selectedInlineSentiment,
  isBlogAndForum,
  isSocial,
  selectedInlineWCType
}) {
  const [chartData, setChartData] = useState({});
  const ref = useRef();

  useEffect(() => {
    setGraphRef(ref);
  }, []);

  useEffect(() => {
    redrawChart();
  }, [hcData.length, showPercentage]);

  if (!hcData) {
    return;
  }
  const showLabels = hcData && hcData.length > 5;
  const customLabel = () => {
    if (showPercentage) {
      if (isEmbededWidget) {
        return "<b>{point.name}-{point.percentage:.1f} %";
      }
      return "{point.percentage:.1f} %";
    } else {
      if (isEmbededWidget) {
        return "<b>{point.name}</b>-{point.y}";
      }
      return "{point.y}";
    }
  };
  const redrawChart = () => {
    const options = {
      chart: {
        type: "pie",
      },
      legend: {
        enabled: true,
        margin: 0,
        maxHeight: 65,
      },
      title: {
        text: chartTitle,
        margin: 10,
        style: {
          fontSize: "12px",
          fontWeight: "bold",
          color: "#666",
        },
      },
      exporting: {
        sourceWidth: 1200,
        chartOptions: {
          legend: {
            enabled: true,
            verticalAlign: "top",
            maxHeight: 1000,
            margin: 25,
            y: 70,
          },
          chart: {
            events: {
              load: function () {
                var renderer = this.renderer;
                renderer
                  .text(
                    `${getTimelineText(to_date,from_date,dateHash)}`,
                    getTimelineTextPosition(getTimelineText(to_date,from_date,dateHash)),
                    80
                  )
                  .add();
                renderer
                  .text(
                    `${getInlineFilterText(widget,selectedInlineJournalist,selectedInlinePlatform,selectedInlinePublication,selectedInlineSentiment,isBlogAndForum,isSocial,selectedInlineWCType)} `,
                    getTimelineTextPosition(getInlineFilterText(widget,selectedInlineJournalist,selectedInlinePlatform,selectedInlinePublication,selectedInlineSentiment,isBlogAndForum,isSocial,selectedInlineWCType)),
                    95
                  )
                  .add();
                renderer
                  .image(LOGO.biuLogoBase, 725, 10, 50, 50)
                  .attr({
                    align: "center",
                  })
                  .add();
              },
            },
          },
        },
      },
      series: [{ name: "Count", data: hcData, innerSize: "50%" }],
      plotOptions: {
        pie: {
          allowPointSelect: true,
          shadow: false,
          cursor: "pointer",
          showInLegend: !isEmbededWidget,
          margin: [0, 0, 0, 0],
        },
        series: {
          cursor: "pointer",
          events: {
            click: (e) => handleDoughnutClick(e),
          },
          dataLabels: {
            distance: isEmbededWidget ? 20 : -15,
            format: customLabel(),
          },
        },
      },
    };
    setChartData(options);
    if (setGraphRefList) {
      setGraphRefList(identifier + mediaType, ref);
    }
  };

  const handleDoughnutClick = (e) => {
    try {
      const label = e.point.options.name;
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
      };
      if (
        type == VERTICALS.V_SOCIAL ||
        type == VERTICALS.V_FORUM ||
        type == VERTICALS.V_BLOG
      ) {
        routeParams.language = label;
      } else {
        const clickedLanguage = dataByReportType.filter((e) => {
          return e.language_name == label;
        });
        if (clickedLanguage && clickedLanguage[0]) {
          routeParams.language = clickedLanguage[0].laguage_id;
        }
      }
      onEntityClick(e, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };

  return (
    <div id={`hc-${identifier}`}>
      <HighchartsReact highcharts={Highcharts} options={chartData} ref={ref} />
    </div>
  );
}

DoughnutChartHC.defaultProps = {
  graphApiResponse: {},
  chartTitle: "",
  onEntityClick: () => {},
  showPercentage: false,
  selectedDataType: "",
  identifier: "",
  setGraphRef: () => {},
  setGraphRefList: () => {},
  dataByReportType: {},
};
